import axiosInstance from "../api/axiosConfig";
import axiosInstanceBackUp from "../api/axiosConfigBackup";
import graphqlAxiosInstance from "./graphqlAxiosConfig";

export const getNewMovies = (page = 1) => axiosInstance.get(`/danh-sach/phim-moi-cap-nhat?page=${page}`);
export const getPhimLe  = () =>  axiosInstance.get(`/v1/api/danh-sach/phim-le`);
export const getPhimBo  = () =>  axiosInstance.get(`/v1/api/danh-sach/phim-bo`);
export const getPhimHoatHinh  = () =>  axiosInstance.get(`/v1/api/danh-sach/hoat-hinh`);
export const TvShow  = () =>  axiosInstance.get(`/v1/api/danh-sach/tv-shows`);

export const getMovieDetail = (slug) => axiosInstance.get(`/phim/${slug}`);
export const getMovieDetailBackUp = (slug) => axiosInstanceBackUp.get(`/phim/${slug}`);
export const searchMovies = (keyword, limit = 100) =>
  axiosInstance.get(`/v1/api/tim-kiem`, { params: { keyword, limit } });

export const getMoviesByCategory = (category, page = 1, limit = 10) =>
  axiosInstance.get(`/v1/api/danh-sach/${category}`, { params: { page, limit } });

export const graphqlRequest = (query, variables = {}) =>
  graphqlAxiosInstance.post("/", {query,variables,});